import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { OfferPerformance } from './productTypes';
import { formatCurrency } from '../FinancialDashboardController';

interface Props {
  offers: OfferPerformance[];
}

const OfferPerformanceSection: React.FC<Props> = ({ offers }) => {
  const { t } = useTranslation();

  if (offers.length < 5) {
    return (
      <div className="offer-performance-section">
        <div className="section-header">
          <h2>{t('productsdashboard.offer-performance')}</h2>
        </div>
        <div className="no-offers">
          {t('productsdashboard.no-offers')}
        </div>
      </div>
    );
  }

  return (
    <div className="offer-performance-section">
      <div className="section-header">
        <h2>{t('productsdashboard.offer-performance')}</h2>
        {offers.length >= 5 && (
          <Link to="/financial-dashboard/offers" className="view-all-btn">
            {t('productsdashboard.view-all-offers')} ({offers.length})
          </Link>
        )}
      </div>
      <div className="offer-cards-container">
        {offers.slice(0, 5).map(offer => (
          <div
            key={offer.OfferCode}
            className={`offer-card performance-${offer.Performance}`}
          >
            <div className="offer-header">
              <h3>{offer.OfferTitle}</h3>
              <span className="offer-code">{offer.OfferCode}</span>
            </div>

            <div className="offer-discount">
              {offer.DiscountPercentage > 0
                ? `${offer.DiscountPercentage}% ${t('productsdashboard.off')}`
                : offer.FixedPrice > 0
                ? formatCurrency(offer.FixedPrice)
                : t('productsdashboard.special-price')
              }
            </div>

            <div className="offer-metrics">
              <div className="metric">
                <span className="label">{t('productsdashboard.revenue')}</span>
                <span className="value">{formatCurrency(offer.TotalRevenue)}</span>
              </div>
              <div className="metric">
                <span className="label">{t('productsdashboard.products-sold')}</span>
                <span className="value">{offer.ProductsSold}</span>
              </div>
              <div className="metric">
                <span className="label">{t('productsdashboard.avg-per-transaction')}</span>
                <span className="value">{formatCurrency(offer.AvgRevenuePerTransaction)}</span>
              </div>
            </div>

            <div className={`performance-badge ${offer.Performance}`}>
              {t(`productsdashboard.performance-rating.${offer.Performance}`)}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default OfferPerformanceSection;
